import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import {
  IconChevronLeft,
  IconChevronRight,
  IconMinus,
  IconPlus,
} from "@tabler/icons-react"
import type { FC } from "react"

import { MAX_ZOOM, MIN_ZOOM } from "./pdfViewerMath"

type PdfViewerControlsProps = {
  currentPage: number
  totalPages: number
  scale: number
  onPrevPage: () => void
  onNextPage: () => void
  onZoomIn: () => void
  onZoomOut: () => void
}

export const PdfViewerControls: FC<PdfViewerControlsProps> = ({
  currentPage,
  totalPages,
  scale,
  onPrevPage,
  onNextPage,
  onZoomIn,
  onZoomOut,
}) => {
  const { translate } = useTranslation()
  const totalPagesLabel = totalPages > 0 ? totalPages : "..."

  return (
    <div className="border-gray-200 bg-gray-50 flex items-center justify-center gap-4 border-b px-2 py-1">
      <div className="flex items-center gap-2">
        <button
          onClick={onPrevPage}
          disabled={currentPage <= 1}
          className="hover:bg-gray-200 rounded p-1 disabled:cursor-not-allowed disabled:opacity-50"
          title={translate("PDF_VIEWER/PREVIOUS_PAGE")}
        >
          <IconChevronLeft size={20} />
        </button>
        <span className="text-sm">
          {currentPage} / {totalPagesLabel}
        </span>
        <button
          onClick={onNextPage}
          disabled={!totalPages || currentPage >= totalPages}
          className="hover:bg-gray-200 rounded p-1 disabled:cursor-not-allowed disabled:opacity-50"
          title={translate("PDF_VIEWER/NEXT_PAGE")}
        >
          <IconChevronRight size={20} />
        </button>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onZoomOut}
          disabled={scale <= MIN_ZOOM}
          className="hover:bg-gray-200 rounded p-1 disabled:cursor-not-allowed disabled:opacity-50"
          title={translate("PDF_VIEWER/ZOOM_OUT")}
        >
          <IconMinus size={20} />
        </button>
        <span className="text-sm">{Math.round(scale * 100)}%</span>
        <button
          onClick={onZoomIn}
          disabled={scale >= MAX_ZOOM}
          className="hover:bg-gray-200 rounded p-1 disabled:cursor-not-allowed disabled:opacity-50"
          title={translate("PDF_VIEWER/ZOOM_IN")}
        >
          <IconPlus size={20} />
        </button>
      </div>
    </div>
  )
}
